// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as TftSet from "common/src/data/TftSet.bs.js";
import * as Caml_obj from "rescript/lib/es6/caml_obj.js";
import * as ItemImage from "common/src/tft-static/ItemImage.bs.js";
import * as UnitImage from "common/src/tft-static/UnitImage.bs.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as FullSearch from "../components/FullSearch.bs.js";
import * as TraitImage from "common/src/tft-static/TraitImage.bs.js";
import * as Translation from "common/src/bindings/Translation.bs.js";
import * as AugmentImage from "common/src/tft-static/AugmentImage.bs.js";
import * as ContentSection from "common/src/ContentSection.bs.js";
import * as PositionSquare from "../player/PositionSquare.bs.js";
import Select from "@mui/material/Select";
import Switch from "@mui/material/Switch";
import Tooltip from "@mui/material/Tooltip";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import InfoOutlined from "@mui/icons-material/InfoOutlined";

function TcHeader$Info(Props) {
  return React.createElement("div", {
              className: "leading-snug"
            }, React.createElement("div", undefined, "Both unfinished and completed compositions are taken into account when calculating stats."));
}

var Info = {
  make: TcHeader$Info
};

function TcHeader(Props) {
  var globalAvgPlace = Props.globalAvgPlace;
  var setFilters = Props.setFilters;
  var sortOrder = Props.sortOrder;
  var setSortOrder = Props.setSortOrder;
  var hideLowPlayrates = Props.hideLowPlayrates;
  var setHideLowPlayrates = Props.setHideLowPlayrates;
  var expandSubcomps = Props.expandSubcomps;
  var setExpandSubcomps = Props.setExpandSubcomps;
  var t = Translation.useT(/* Common */0);
  var set = TftSet.use(undefined);
  var searchOptions = React.useMemo((function () {
          return FullSearch.getCompsOptions(set);
        }), []);
  var match = React.useState(function () {
        return [];
      });
  var setNewFilters = match[1];
  var newFilters = match[0];
  React.useEffect((function () {
          Curry._1(setFilters, (function (param) {
                  return Belt_Array.keepMap(newFilters, (function (v) {
                                switch (v.TAG | 0) {
                                  case /* Unit */0 :
                                      return {
                                              TAG: /* Unit */1,
                                              _0: v._0
                                            };
                                  case /* Trait */1 :
                                      return {
                                              TAG: /* Trait */0,
                                              _0: v._0,
                                              _1: v._1
                                            };
                                  default:
                                    return ;
                                }
                              }));
                }));
          
        }), [newFilters]);
  return React.createElement(ContentSection.make, {
              className: "w-full",
              children: null
            }, React.createElement("div", {
                  className: "flex items-center pt-1 pb-4"
                }, React.createElement("div", undefined, React.createElement("h4", {
                          className: "text-xl font-medium"
                        }, t("Team Compositions"))), React.createElement(Tooltip, {
                      title: React.createElement(TcHeader$Info, {
                            globalAvgPlace: globalAvgPlace
                          }),
                      children: React.createElement("div", {
                            className: "ml-1 cursor-pointer"
                          }, React.createElement(InfoOutlined, {
                                fontSize: "small"
                              }))
                    })), React.createElement("div", {
                  className: "flex flex-col sm:flex-row sm:items-end"
                }, React.createElement(FormControl, {
                      variant: "standard",
                      children: null
                    }, React.createElement(InputLabel, {
                          children: t("Sort by")
                        }), React.createElement(Select, {
                          label: "Sort by",
                          value: sortOrder,
                          onChange: (function (e) {
                              var v = e.target.value;
                              return Curry._1(setSortOrder, (function (param) {
                                            return v;
                                          }));
                            }),
                          className: "w-[100px]",
                          variant: "standard",
                          children: null
                        }, React.createElement(MenuItem, {
                              value: /* Popularity */0,
                              children: t("Play Rate")
                            }), React.createElement(MenuItem, {
                              value: /* Place */1,
                              children: t("Avg. Place")
                            }), React.createElement(MenuItem, {
                              value: /* Top4 */2,
                              children: t("Top 4 Rate")
                            }), React.createElement(MenuItem, {
                              value: /* Win */3,
                              children: t("Win Rate")
                            }))), React.createElement("div", {
                      className: "pt-2 sm:pt-0 sm:pl-4 flex flex items-center gap-2"
                    }, React.createElement("div", {
                          className: "text-lg font-montserrat font-medium"
                        }, t("Filters") + ":"), React.createElement(FullSearch.make, {
                          onChange: (function (v) {
                              return Curry._1(setNewFilters, (function (fs) {
                                            return Belt_Array.concat(fs, [FullSearch.decodeFilter(v)]);
                                          }));
                            }),
                          placeholder: t("Add Filter"),
                          options: searchOptions
                        }), React.createElement("div", {
                          className: "flex gap-1"
                        }, Belt_Array.mapWithIndex(newFilters, (function (idx, f) {
                                var tmp;
                                switch (f.TAG | 0) {
                                  case /* Unit */0 :
                                      tmp = React.createElement(UnitImage.make, {
                                            unitId: f._0,
                                            size: 28
                                          });
                                      break;
                                  case /* Trait */1 :
                                      tmp = React.createElement(TraitImage.PlainIcon2.make, {
                                            traitId: f._0,
                                            rank: f._1,
                                            size: 28
                                          });
                                      break;
                                  case /* Item */2 :
                                      tmp = React.createElement(ItemImage.make, {
                                            itemId: f._0,
                                            size: 28,
                                            rounded: "rounded"
                                          });
                                      break;
                                  case /* Augment */3 :
                                      tmp = React.createElement(AugmentImage.make, {
                                            augId: f._0,
                                            size: 28
                                          });
                                      break;
                                  case /* Places */4 :
                                      tmp = React.createElement(PositionSquare.make, {
                                            size: 26,
                                            pl: Belt_Array.getExn(f._1, 0),
                                            queueId: 1100
                                          });
                                      break;
                                  
                                }
                                return React.createElement(FullSearch.FilterWrap.make, {
                                            children: tmp,
                                            onClick: (function (param) {
                                                return Curry._1(setNewFilters, (function (nfs) {
                                                              return Belt_Array.keep(nfs, (function (f2) {
                                                                            return Caml_obj.caml_notequal(f2, f);
                                                                          }));
                                                            }));
                                              }),
                                            key: String(idx)
                                          });
                              }))))), React.createElement("div", {
                  className: "flex flex-wrap pt-4 pl-[6px] gap-5"
                }, React.createElement(FormControlLabel, {
                      control: React.createElement(Switch, {
                            checked: !hideLowPlayrates,
                            onChange: (function (e) {
                                var v = e.target.checked;
                                return Curry._1(setHideLowPlayrates, (function (param) {
                                              return !v;
                                            }));
                              }),
                            size: "small"
                          }),
                      label: t("Show low play rate compositions")
                    }), React.createElement(FormControlLabel, {
                      control: React.createElement(Switch, {
                            checked: expandSubcomps,
                            onChange: (function (e) {
                                var v = e.target.checked;
                                return Curry._1(setExpandSubcomps, (function (param) {
                                              return v;
                                            }));
                              }),
                            size: "small"
                          }),
                      label: t("Expand all subcomps")
                    })));
}

var make = TcHeader;

export {
  Info ,
  make ,
  
}
/* react Not a pure module */
